// extracted by mini-css-extract-plugin
export var avatar = "_r1-3";
export var avatarContainer = "_r1-2";
export var avatarSpacer = "_r1-5";
export var avatarSpacerContainer = "_r1-4";
export var avatarStackContainer = "_r1-1";
export var bubble = "_r1-0";
export var remainderBubble = "_r1-6";